import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.parcels.title',
    defaultMessage: 'Parcels',
    description: 'title of the parcels page',
  },
  secondaryActions: {
    switchLocations: {
      id: 'pages.parcels.secondaryActions.switchLocations',
      defaultMessage: 'Switch locations',
      description: 'Label of the switch locations action on the parcels page',
    },
  },
  emptyMessage: {
    id: 'pages.parcels.emptyMessage',
    defaultMessage: 'No parcels found',
    description: 'Empty message of the parcels page',
  },
  bulkActions: {
    markInTransit: {
      id: 'pages.parcels.bulkActions.markInTransit',
      defaultMessage: 'Mark in transit',
      description: 'Label of the mark in transit action of the parcels page',
    },
    markFinished: {
      id: 'pages.parcels.bulkActions.markFinished',
      defaultMessage: 'Mark finished',
      description: 'Label of the mark finished action of the parcels page',
    },
  },
  feedback: {
    parcelsMarkedFinished: {
      id: 'pages.parcels.feedback.parcelsMarkedFinished',
      defaultMessage: 'Parcels marked as finished',
      description: 'Success message of the mark finished bulk action of the parcels page',
    },
    parcelsMarkedNotFinished: {
      id: 'pages.parcels.feedback.parcelsMarkedNotFinished',
      defaultMessage: 'Parcels could not be marked as finished',
      description: 'Error message of the mark finished bulk action of the parcels page',
    },
    parcelsMarkedInTransit: {
      id: 'pages.parcels.feedback.parcelsMarkedInTransit',
      defaultMessage: 'Parcels marked as in transit',
      description: 'Success message of the mark in transit bulk action of the parcels page',
    },
    parcelNotFound: {
      id: 'pages.parcels.feedback.parcelNotFound',
      defaultMessage: 'Parcel not found',
      description: 'Parcel not found message on the parcels page',
    },
    parcelsNotMarkedInTransit: {
      id: 'pages.parcels.feedback.parcelsNotMarkedInTransit',
      defaultMessage: 'Parcels could not be marked as in transit',
      description: 'Error message of the mark in transit bulk action of the parcels page',
    },
  },
};

export default defineMessages(translations);
